export function serviciosCitaParaUI(cita, catalogoServicios = []) {
    const entradasServicios = cita?.servicios;
    if (!Array.isArray(entradasServicios) || entradasServicios.length === 0) return [];
    return entradasServicios.map((entrada) => {
        // entrada.servicio puede llegar como string (cita re-fetcheada del BE), como
        // ObjectId o como objeto populado (cita recién creada desde el admin antes
        // de pasar por getCita). Normalizamos a string para que las comparaciones
        // por _id en consumers (find/filter) funcionen consistentemente.
        const servicioRef = entrada.servicio;
        const servicioId = (servicioRef && typeof servicioRef === 'object' ? servicioRef._id : servicioRef) || entrada._id;
        return {
            _id: servicioId,
            nombre: entrada.nombre,
            precio: entrada.precio,
            duracion: entrada.duracionOriginal,
            duracion1: entrada.duracion1,
            pausa: entrada.pausa,
            duracion2: entrada.duracion2,
        };
    });
}

export function varianteDesdeSnapshot(entradaVariante, servicioIdParaFiltrar) {
    const varianteId = entradaVariante.variante || entradaVariante._id;
    if (!varianteId) return null;
    const varianteParaUI = {
        _id: varianteId,
        nombre: entradaVariante.nombre,
        valor: entradaVariante.valor,
        valorType: entradaVariante.valorType,
        tiempo: entradaVariante.tiempo,
        servicios: (entradaVariante.servicioIds || []).map((idServicio) => ({ _id: idServicio })),
    };
    if (servicioIdParaFiltrar && varianteParaUI.servicios.length > 0) {
        const varianteIncluyeServicioFiltrado = varianteParaUI.servicios.some(
            (servicioRef) => String(servicioRef._id) === String(servicioIdParaFiltrar)
        );
        if (!varianteIncluyeServicioFiltrado) return null;
    }
    return varianteParaUI;
}

export function variantesCitaParaUI(cita, variantesRedux = [], servicioIdOpcional) {
    const entradasVariantes = cita?.variantes;
    if (Array.isArray(entradasVariantes) && entradasVariantes.length > 0) {
        return entradasVariantes
            .map((entrada) => varianteDesdeSnapshot(entrada, servicioIdOpcional))
            .filter(Boolean);
    }
    return [];
}

export function promocionesCitaParaUI(cita, promocionesRedux = []) {
    const entradasPromociones = cita?.promociones;
    if (Array.isArray(entradasPromociones) && entradasPromociones.length > 0) {
        return entradasPromociones.map((entrada) => {
            const promocionId = entrada.promocion || entrada._id;
            return {
                _id: promocionId,
                titulo: entrada.titulo,
                tipo: entrada.tipo,
                porcentaje: entrada.porcentaje,
                cifra: entrada.cifra,
            };
        });
    }
    return [];
}

export function serviciosVentaParaUI(venta, catalogoServicios = []) {
    const entradasServicios = venta?.servicios;
    if (!Array.isArray(entradasServicios) || entradasServicios.length === 0) return [];
    return entradasServicios.map((entrada) => {
        const servicioId = entrada.servicio || entrada._id;
        return {
            _id: servicioId,
            nombre: entrada.nombre,
            precio: entrada.precio,
            duracion: entrada.duracionOriginal,
        };
    });
}

export function variantesVentaParaUI(venta, variantesRedux = []) {
    const entradasVariantes = venta?.variantes;
    if (!Array.isArray(entradasVariantes) || entradasVariantes.length === 0) return [];
    return entradasVariantes.map((entrada) => {
        const varianteId = entrada.variante || entrada._id;
        return {
            _id: varianteId,
            nombre: entrada.nombre,
            valor: entrada.valor,
            valorType: entrada.valorType,
        };
    });
}

export function promocionesVentaParaUI(venta, promocionesRedux = []) {
    const entradasPromociones = venta?.promociones;
    if (!Array.isArray(entradasPromociones) || entradasPromociones.length === 0) return [];
    return entradasPromociones.map((entrada) => {
        const promocionId = entrada.promocion || entrada._id;
        return {
            _id: promocionId,
            titulo: entrada.titulo,
            porcentaje: entrada.porcentaje,
            cifra: entrada.cifra,
        };
    });
}

export function productosVentaParaUI(venta, productosRedux = []) {
    const entradasProductos = venta?.productos;
    if (!Array.isArray(entradasProductos) || entradasProductos.length === 0) return [];
    return entradasProductos.map((entrada) => {
        const productoId = entrada.producto || entrada._id;
        return {
            _id: productoId,
            titulo: entrada.titulo,
            nombre: entrada.titulo,
            precio: entrada.precio,
        };
    });
}

export function resolverServicioEnCita(cita, servicioId, catalogoServicios = []) {
    if (!cita || servicioId == null) return null;
    const servicioIdBuscado = String(servicioId);
    const entrada = (cita.servicios || []).find(
        (e) => String(e.servicio || e._id) === servicioIdBuscado
    );
    if (!entrada) return null;
    return {
        _id: entrada.servicio || entrada._id,
        nombre: entrada.nombre,
        precio: entrada.precio,
        duracion: entrada.duracionOriginal,
        duracion1: entrada.duracion1,
        pausa: entrada.pausa,
        duracion2: entrada.duracion2,
    };
}

export function nombreServicioDesdeDetalle(servicioDetalle, cita, catalogoServicios = []) {
    if (servicioDetalle?.nombre) return servicioDetalle.nombre;
    const servicioRef = servicioDetalle?.servicio;
    const servicioIdReferencia = servicioRef?._id || servicioRef;
    if (servicioIdReferencia) {
        const servicioResuelto = resolverServicioEnCita(cita, servicioIdReferencia, catalogoServicios);
        if (servicioResuelto?.nombre) return servicioResuelto.nombre;
    }
    return 'Servicio';
}

export function nombresServiciosListadoCita(cita, catalogoServicios = []) {
    const serviciosParaListado = serviciosCitaParaUI(cita, catalogoServicios);
    if (serviciosParaListado.length > 0) {
        return serviciosParaListado.map((servicio) => servicio.nombre).filter(Boolean).join(', ') || 'Sin servicio';
    }
    return 'Sin servicio';
}

export function nombreVarianteParaDisplay(varianteIdOrObj, cita, variantesRedux) {
    const varianteId = varianteIdOrObj && (varianteIdOrObj._id || varianteIdOrObj);
    if (!varianteId) return null;
    const entradaVariante = (cita?.variantes || []).find(
        (entrada) => String(entrada.variante || entrada._id) === String(varianteId)
    );
    if (entradaVariante?.nombre) return entradaVariante.nombre;
    const varianteEnRedux = variantesRedux?.find((itemVariante) => String(itemVariante._id || itemVariante) === String(varianteId));
    return varianteEnRedux?.nombre || null;
}
